'use client';

import Image from 'next/image';
import React, { ForwardedRef, forwardRef } from 'react';

interface PostCustomImageProps {
    src: string;
    alt?: string;
    width: number;
    height: number;
}

const PostCustomImage = forwardRef<HTMLImageElement, PostCustomImageProps>(
    ({ src, alt, width, height }, ref: ForwardedRef<HTMLImageElement>) => {
        return (
            <Image
                ref={ref}
                src={src}
                alt={alt || 'default_alt'}
                title={alt}
                loading='lazy'
                className='rounded-2xl overflow-hidden mx-auto'
                width={width}
                height={height}
                sizes='(min-width: 808px) 50vw, 100vw'
            />
        );
    },
);

PostCustomImage.displayName = 'PostCustomImage';
export default PostCustomImage;
